import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import { handleKeyDownForTextInput } from "./utils";

const INPUT_LIMIT = 50;

const TitleTextAndSelection = ({
  selection,
  placeholder,
  setSelection,
  selectionList,
}) => {
  const colors = useColors();

  return (
    <Autocomplete
      freeSolo
      value={selection || ""}
      onChange={(_, newValue) => setSelection(newValue || "")}
      onInputChange={(_, newValue) => setSelection(newValue || "")}
      options={selectionList}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="standard"
          value={selection || ""}
          onKeyDown={(event) => handleKeyDownForTextInput(event)}
          inputProps={{
            ...params.inputProps,
            maxLength: INPUT_LIMIT,
          }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            sx: {
              borderBottom: `2px solid ${colors.grey_32percent}`,
              "& .MuiInputBase-input": {
                color: colors.text_primary,
                fontSize: "12px",
                marginTop: "3px",
                "&::placeholder": {
                  color: colors.gray_soft,
                  opacity: 1,
                },
              },
            },
          }}
        />
      )}
      renderOption={(props, option) => {
        let optionTitle = option;
        if (!selectionList.includes(option)) optionTitle = `Add "${option}"`;
        return (
          <Box
            component="li"
            {...props}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Typography variant="caption">{optionTitle}</Typography>
          </Box>
        );
      }}
      filterOptions={(options, params) => {
        const { inputValue } = params;
        let filteredOptions = options.filter((option) =>
          option.toLowerCase().startsWith(inputValue.toLowerCase())
        );

        if (inputValue !== "" && !options.includes(inputValue)) {
          filteredOptions = [inputValue, ...filteredOptions];
        }

        return filteredOptions;
      }}
    />
  );
};

export default TitleTextAndSelection;
